import { ArrowForward, CloseOutlined, DeleteOutline, EditOutlined, PauseOutlined, PlayArrowOutlined } from '@mui/icons-material';
import { Avatar, Box, Card, Checkbox, Chip, Divider, FormControl, Grid, IconButton, InputAdornment, LinearProgress, Link, List, ListItem, Menu, MenuItem, Paper, Popover, Select, Stack, Tab, Tabs, TextField, Typography } from '@mui/material';
import { Copy } from 'lucide-react';
import React, { useState } from 'react'
import { BsCartCheck } from "react-icons/bs";
import { IoIosTrendingUp } from 'react-icons/io';
import { IoReceiptOutline, IoWalletOutline } from 'react-icons/io5';
import CloseIcon from "@mui/icons-material/Close";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import statusIcon from "../../../assets/svg/Check icon.svg"
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import SearchIcon from "@mui/icons-material/Search";
import CheckIcon from "@mui/icons-material/Check";
import { DataGrid } from '@mui/x-data-grid';
import { Area, AreaChart, CartesianGrid, Cell, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { FaCarBattery, FaGift, FaUmbrellaBeach } from 'react-icons/fa6';
import { RiOilFill } from 'react-icons/ri';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import agentimg from "../../../assets/svg/Ellipse 12.svg"
import { GiCarWheel, GiSheep } from "react-icons/gi";
import { MdOutlineLocalCarWash } from 'react-icons/md';
import { HiOutlineUserGroup, HiOutlineUsers } from "react-icons/hi";
import { GrUserSettings } from "react-icons/gr";
import { GoClock } from "react-icons/go";



function StatusInfoPopover({ anchorEl, onClose, data }) {
    const open = Boolean(anchorEl);

    if (!data) return null;

    const { status } = data;

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            slotProps={{
                paper: {
                    sx: {
                        width: 260,
                        maxWidth: "90vw",
                        p: 2,
                        borderRadius: "10px",
                        boxShadow: "0px 4px 20px rgba(0,0,0,0.12)",
                    },
                },
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 600 }}>Status Information</Typography>
                <IconButton size="small" onClick={onClose} sx={{ p: 0.3 }}>
                    <CloseIcon sx={{ fontSize: 16 }} />
                </IconButton>
            </Box>

            <Divider sx={{ mb: 1.5 }} />

            <Box sx={{ bgcolor: data?.bgColor, p: 1, borderRadius: 2, my: 1 }}>
                <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>Current Status</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.7, mb: 1.5 }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: data?.color }} />
                    <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{data?.name}</Typography>
                </Box>
            </Box>

            {data?.name === "Active" && (
                <>
                    <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>Activation</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>{data?.activate}</Typography>

                    <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>{data?.status_date}</Typography>

                    <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>Triggered By</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>{data?.status_by}</Typography>
                </>
            )}

            {data?.name === "Scheduled" && (
                <>
                    <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>Start Date</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>{data?.start_date}</Typography>

                    <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>End Date</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>{data?.end_date}</Typography>

                    <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>Triggered By</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>{data?.status_by}</Typography>
                </>
            )}

            {data?.name === "Draft" && (
                <>
                    <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>Created By</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>{data?.status_by}</Typography>

                    <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>Created Date</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>{data?.status_date}</Typography>

                    <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>Last Edited</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>{data?.edit_date}</Typography>
                </>
            )}

            <Box sx={{ display: "flex", gap: 0.8, bgcolor: data?.bgColor, borderRadius: "8px", p: 1, alignItems: "flex-start" }}>
                <InfoOutlinedIcon sx={{ fontSize: 15, color: data?.color, mt: "1px" }} />
                <Typography sx={{ fontSize: 11.5, color: "text.secondary", lineHeight: 1.4 }}>{data?.note}</Typography>
            </Box>
        </Popover>
    );
}



const OffersIncentives = () => {
    const stats = [
        { title: "Total Offers", value: 256, subtitle: "18% vs last 30 days" },
        { title: "Active", value: 148, subtitle: "8% vs last 30 days" },
        { title: "Scheduled", value: 28, subtitle: "14% vs last 30 days" },
        { title: "Draft", value: 34, subtitle: "In progress" },
        { title: "Under Review", value: 18, subtitle: "In review" },
        { title: "Paused", value: 6, subtitle: "9% vs last 30 days" },
        { title: "Expired", value: 46, subtitle: "-5% vs last 30 days" },
        { title: "Disabled", value: 12, subtitle: "9% vs last 30 days" },
    ];

    const OffersPerformance = [
        { name: "Orders from Offers", text: "12,450", icon: <BsCartCheck />, bg: "#F4F8F0", color: "#8CB369", description: "18% vs last 30 days" },
        { name: "Revenue Generated", text: "1,250,000 EGP", icon: <IoWalletOutline />, bg: "#FFFAEA", color: "#FEB91E", description: "18% vs last 30 days" },
        { name: "Avg. Order Value", text: "750 EGP", icon: <IoReceiptOutline />, bg: "#F6E9FC", color: "#7E1BAD", description: "18% vs last 30 days" },
        { name: "Conversion Rate", text: "18.6%", icon: <IoIosTrendingUp />, bg: "#ECF9F7", color: "#3FBEAC", description: "18% vs last 30 days" },
    ];

    const [selectedRows, setSelectedRows] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedStatusData, setSelectedStatusData] = useState(null);
    const [selectedInfoRows, setSelectedInfoRows] = useState([]);

    const handleStatusInfoOpen = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedStatusData(row);
    };

    const handleStatusInfoClose = () => {
        setAnchorEl(null);
        setSelectedStatusData(null);
    };

    const columns = [
        { field: "id", headerName: "ID", flex: 0.6, minWidth: 80 },
        { field: "name", headerName: "Offer Name", flex: 1, minWidth: 140 },
        { field: "code", headerName: "Offer Code", flex: 1, minWidth: 140 },
        { field: "type", headerName: "Type", flex: 1, minWidth: 120 },
        { field: "category", headerName: "Category", flex: 0.7, minWidth: 90 },
        { field: "discount", headerName: "Discount", flex: 1, minWidth: 120 },
        { field: "budget", headerName: "Budget", flex: 1, minWidth: 120 },
        { field: "orders", headerName: "Orders", flex: 1, minWidth: 100 },
        { field: "revenue", headerName: "Revenue", flex: 1, minWidth: 120 },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 1 }}>
                        <Chip
                            label={params.row.status.name}
                            size="medium"
                            sx={{ bgcolor: params.row.status?.bgColor, fontWeight: 500 }}
                        />
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleStatusInfoOpen(e, params.row.status);
                            }}
                        >
                            <InfoOutlinedIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                        </IconButton>
                    </Box>
                );
            },
        },
        { field: "validity", headerName: "Validity", flex: 1, minWidth: 160 },
        { field: "lastUpdate", headerName: "Last Update", flex: 1, minWidth: 140 },
        {
            field: "actions",
            headerName: "Actions",
            flex: 0.6,
            minWidth: 90,
            sortable: false,
            renderCell: (params) => (
                <>
                    <IconButton
                        disableRipple
                        size="small"
                        onClick={(e) => {
                            handleClick(e, params.row);
                            e.stopPropagation();
                        }}
                    >
                        <MoreVertIcon fontSize="small" />
                    </IconButton>
                    <Menu
                        anchorEl={menuState.anchorEl}
                        open={Boolean(menuState.anchorEl)}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        slotProps={{ paper: { sx: { borderRadius: 2, p: 1, backgroundColor: "#F9F9F9" } } }}
                    >
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#000" }}>
                            <RemoveRedEyeOutlinedIcon fontSize="small" /> View Details
                        </MenuItem>
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#000" }}>
                            <EditOutlined fontSize="small" /> Edit
                        </MenuItem>
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#159D89" }}>
                            <PlayArrowOutlined fontSize="small" /> Activate Now
                        </MenuItem>
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#E6A209" }}>
                            <PauseOutlined fontSize="small" /> Pause
                        </MenuItem>
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#000" }}>
                            <Copy size={14} /> Duplicate
                        </MenuItem>
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#A80101" }}>
                            <CloseIcon fontSize="small" /> Disable
                        </MenuItem>
                    </Menu>
                </>
            ),
        },
    ];

    const rows = [
        {
            id: "OFF-001", name: "Welcome Combo", code: "WELCOME COMBO", type: "Bundle Offer", category: "Maintenance",
            discount: "20% OFF", budget: "300,000 EGP", orders: "2,450", revenue: "245,000 EGP", validity: "Mar 10 - May 31, 2025",
            status: { name: "Active", color: "#3FBEAC", bgColor: "#ECF9F7", note: "This coupon was activated automatically when the start date reached.", start_date: null, end_date: null, status_date: "08 Jul 2026 - 10:00 am", edit_date: null, status_by: "System Scheduler", activate: "Automatic" },
            lastUpdate: "2h ago Mona Ali",
        },
        {
            id: "OFF-002", name: "Battery + installation", code: "BATINSTALL", type: "Bundle Offer", category: "Battery",
            discount: "15% OFF", budget: "300,000 EGP", orders: "1,980", revenue: "180,500 EGP", validity: "Mar 10 - May 31, 2025",
            status: { name: "Active", color: "#3FBEAC", bgColor: "#ECF9F7", note: "This coupon was activated automatically when the start date reached.", start_date: null, end_date: null, status_date: "08 Jul 2026 - 10:00 am", edit_date: null, status_by: "System Scheduler", activate: "Automatic" },
            lastUpdate: "3h ago Mona Ali",
        },
        {
            id: "OFF-003", name: "Weekend Special", code: "WEEKEND20", type: "Discount Offer", category: "Maintenance",
            discount: "20% OFF", budget: "150,000 EGP", orders: "1,650", revenue: "150,000 EGP", validity: "Mar 10 - May 31, 2025",
            status: { name: "Active", color: "#3FBEAC", bgColor: "#ECF9F7", note: "This coupon was activated automatically when the start date reached.", start_date: null, end_date: null, status_date: "08 Jul 2026 - 10:00 am", edit_date: null, status_by: "System Scheduler", activate: "Automatic" },
            lastUpdate: "5h ago Ahmed Hassan",
        },
    ];

    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [menuState, setMenuState] = useState({ anchorEl: null, row: null });

    const handleClose = () => setMenuState({ anchorEl: null, row: null });
    const handleClick = (event, row) => setMenuState({ anchorEl: event.currentTarget, row });

    const handleActivate = () => console.log(selectedRows);
    const handleReset = () => setSelectedRows([]);
    const handlePause = () => console.log(selectedRows);
    const handleDelete = () => console.log(selectedRows);

    const data = [
        { date: "Apr 22", value: 35000 }, { date: "Apr 23", value: 38000 }, { date: "Apr 24", value: 45000 },
        { date: "Apr 25", value: 62000 }, { date: "Apr 26", value: 92000 }, { date: "Apr 27", value: 130000 },
        { date: "Apr 28", value: 162000 }, { date: "Apr 29", value: 175000 }, { date: "Apr 30", value: 170000 },
        { date: "May 01", value: 145000 }, { date: "May 02", value: 110000 }, { date: "May 03", value: 80000 },
        { date: "May 04", value: 60000 }, { date: "May 05", value: 52000 }, { date: "May 06", value: 70000 },
        { date: "May 07", value: 100000 }, { date: "May 08", value: 95000 }, { date: "May 09", value: 65000 },
        { date: "May 10", value: 50000 }, { date: "May 11", value: 55000 }, { date: "May 12", value: 80000 },
        { date: "May 13", value: 130000 }, { date: "May 14", value: 158000 }, { date: "May 15", value: 145000 },
        { date: "May 16", value: 100000 }, { date: "May 17", value: 60000 }, { date: "May 18", value: 32000 },
        { date: "May 19", value: 35000 }, { date: "May 20", value: 42000 }, { date: "May 21", value: 50000 },
    ];

    const visibleTicks = ["Apr 22", "Apr 29", "May 06", "May 13", "May 20"];

    const donutData = [
        { name: "Active", value: 148, color: "#3FBEAC" },
        { name: "Scheduled", value: 28, color: "#7E1BAD" },
        { name: "Draft", value: 37, color: "#8CB369" },
        { name: "Under Review", value: 34, color: "#FEB91E" },
        { name: "Paused", value: 7, color: "#FC6C4F" },
        { name: "Expired", value: 46, color: "#696969" },
        { name: "Disabled", value: 12, color: "#A80101" },
    ];

    const total = donutData.reduce((sum, item) => sum + item.value, 0);

    const mostPurchased = [
        { name: "Battery", orders: "5,230 orders", value: 89, bg: "#FFF4F0", icon: <FaCarBattery color="#FC6C4F" size={20} /> },
        { name: "Oil Change", orders: "4,000 orders", value: 49, bg: "#FFFAEA", icon: <RiOilFill color="#FEB91E" size={20} /> },
        { name: "Car Care", orders: "2,830 orders", value: 22, bg: "#F0F8FF", icon: <MdOutlineLocalCarWash color="#3E9FF6" size={20} /> },
        { name: "Tire Service", orders: "880 orders", value: 14, bg: "#F8F8F8", icon: <GiCarWheel color="#696969" size={20} /> },
    ];

    const userSegments = [
        { name: "VIP Customers", value: 28, icon: <HiOutlineUserGroup color="#FFF" size={18} /> },
        { name: "New Customers", value: 42, icon: <GrUserSettings color="#FFF" size={18} /> },
        { name: "Existing Customers", value: 18, icon: <HiOutlineUsers color="#FFF" size={18} /> },
        { name: "Infrequent Users", value: 12, icon: <GoClock color="#FFF" size={18} /> },
    ];

    const topOffers = [
        { name: "Welcome Combo", revenue: "245,000 EGP", roi: "6.2x", icon: <FaGift color="#3FBEAC" size={18} /> },
        { name: "Battery + Installation", revenue: "180,800 EGP", roi: "5.1x", icon: <FaCarBattery color="#FC6C4F" size={18} /> },
        { name: "Weekend Special", revenue: "150,090 EGP", roi: "5.1x", icon: <FaUmbrellaBeach color="#FEB91E" size={18} /> },
        { name: "Eid al-Adha Offer", revenue: "120,500 EGP", roi: "3.6x", icon: <GiSheep color="#535353" size={18} /> },
    ];

    const expiringSoon = [
        { name: "Welcome Combo", expires: "Expires in 2 days", icon: <FaGift color="#3FBEAC" size={18} /> },
        { name: "Weekend Special", expires: "Expires in 5 days", icon: <FaUmbrellaBeach color="#DA9907" size={18} /> },
        { name: "Battery + Installation", expires: "Expires in 7 days", icon: <FaCarBattery color="#FC6C4F" size={18} /> },
        { name: "Eid al-Adha Offer", expires: "Expires in 10 days", icon: <GiSheep color="#535353" size={18} /> },
    ];

    const recentActivity = [
        { user: "Osama Ali", action: "created offer", offer: "Welcome Combo", time: "20m ago" },
        { user: "Ahmed Hassan", action: "updated offer", offer: "Battery + Installation", time: "1h ago" },
        { user: "Ahmed Hassan", action: "paused offer", offer: "Weekend Special", time: "1h ago" },
        { user: "Ahmed Hassan", action: "disabled offer", offer: "Free Checkup Offer", time: "1h ago" },
        { user: "Mona Salah", action: "updated offer settings", offer: "Eid Mega Offer", time: "2h ago" },
    ];

  const mockFunnelData = [
    { name: "Offer Views", value: 45320, fill: "#1B9F91" },
    { name: "Offer Clicks", value: 22140, fill: "#3FBEAC" },
    { name: "Added to Cart", value: 15230, fill: "#5DE3D0" },
    { name: "Purchased", value: 12450, fill: "#85F8E8" },
];

const FunnelChart = ({ data = mockFunnelData }) => {
    const n = data.length;
    const rowHeight = 40;
    const totalHeight = rowHeight * n;
    const baseWidth = 180;
    const firstValue = data[0]?.value || 1;

    const bands = data.map((item, i) => {
        const y0 = i * rowHeight;
        const y1 = (i + 1) * rowHeight;
        const topRatio = 1 - i / n;
        const bottomRatio = 1 - (i + 1) / n;
        const w0 = baseWidth * topRatio;
        const w1 = baseWidth * bottomRatio;
        const cx = baseWidth / 2;

        const points = [
            [cx - w0 / 2, y0],
            [cx + w0 / 2, y0],
            [cx + w1 / 2, y1],
            [cx - w1 / 2, y1],
        ]
            .map((p) => p.join(","))
            .join(" ");

        return { points, fill: item.fill, midY: (y0 + y1) / 2 };
    });

    return (
        <Box sx={{ display: "flex", alignItems: "center", my:2, height:
            "100%", justifyContent:"space-between"
         }}>
          <Box>
              <svg width={baseWidth} height={totalHeight} viewBox={`0 0 ${baseWidth} ${totalHeight}`}>
                {bands.map((band, i) => (
                    <polygon key={i} points={band.points} fill={band.fill} />
                ))}
            </svg>
          </Box>

            <Box sx={{ display: "flex", flexDirection: "column", width:"100%" }}>
                {data.map((stage, i) => (
                    <Box
                        key={stage.name}
                        sx={{
                            height: rowHeight,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 1,
                            width:"100%"

                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1,}}>
                            {/* <Box sx={{ width:30, borderTop: "1px solid #999" }} /> */}
                            <Typography sx={{ fontSize: 12, color: "text.secondary"}}>
                                {stage.name}
                            </Typography>
                        </Box>
          <Box sx={{ display: "flex", alignItems: "center",  }} >
 <Typography sx={{ fontSize: 12, fontWeight: 500, whiteSpace: "none" }}>
                            {stage.value.toLocaleString()}{" "}
                            <Box component="span" sx={{ color: "text.secondary", fontWeight: 400 }}>
                                ({((stage.value / firstValue) * 100).toFixed(1)}%)
                            </Box>
                        </Typography>
          </Box>
 

                    </Box>
                ))}
            </Box>
        </Box>
    );
};
 


    return (
        <Box sx={{ m: { xs: 2, md: 4 } }}>
            {/* Header */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
                <Box>
                    <Typography variant="h5" fontWeight={700}>Offers</Typography>
                    <Typography color="text.secondary" fontSize={14}>Track performance of all offers and bundles across the platform.</Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <button className="btn btn-dark px-3 d-flex align-items-center">
                        <AddIcon sx={{ mr: 1, fontSize: 20 }} />
                        Create Offer
                    </button>
                    <button className="btn btn-light d-flex align-items-center">
                        <FileDownloadOutlinedIcon sx={{ color: "#535353", mr: 1, fontSize: 20 }} />
                        Export
                    </button>
                </Box>
            </Box>

            <Grid container spacing={2} sx={{ py: 3 }} alignItems="stretch">
                {stats.map((item) => (
                    <Grid item xs={12} sm={6} md={3} key={item.title} sx={{ display: "flex" }}>
                        <Card
                            elevation={0}
                            sx={{
                                border: "1px solid #ECECEC",
                                boxShadow: "0px 1px 4px rgba(0,0,0,0.04)",
                                borderRadius: 3,
                                px: 2.5,
                                py: 2,
                                width: "100%",
                            }}
                        >
                            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                <Box component="img" src={statusIcon} alt="status" sx={{ width: 24, height: 24 }} />
                                <Typography fontWeight={600} fontSize={14}>{item.title}</Typography>
                            </Box>
                            <Typography fontWeight={700} fontSize={22} sx={{ mt: 1 }}>{item.value}</Typography>
                            <Typography color="text.secondary" fontSize={12}>{item.subtitle}</Typography>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <Card elevation={0} sx={{ border: "1px solid #ECECEC", borderRadius: 4, p: 3, mb: 2 }}>
                <Box sx={{ py: 1, borderBottom: "1px solid #ECECEC", mb: 1 }}>
                    <Typography fontWeight={600}>
                        Offers Performance <Typography component="span" color="text.secondary" fontSize={13}>(Last 30 Days)</Typography>
                    </Typography>
                </Box>

                <Grid container spacing={3}>
                    {OffersPerformance.map((item, i, arr) => (
                        <Grid item xs={12} sm={6} md={3} key={item.name}>
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 2,
                                    alignItems: "center",
                                    height: "100%",
                                    pr: { md: i < arr.length - 1 ? 3 : 0 },
                                    borderInlineEnd: { md: i < arr.length - 1 ? "1px solid #E8E8E8" : "none" },
                                }}
                            >
                                <Avatar sx={{ bgcolor: item.bg, color: item.color, flexShrink: 0 }}>{item.icon}</Avatar>
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography color="text.secondary" fontSize={12} noWrap>{item.name}</Typography>
                                    <Typography fontSize={14} fontWeight={600} noWrap>{item.text}</Typography>
                                    <Typography fontSize={12} color="text.secondary" noWrap>{item.description}</Typography>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Card>

            <Grid container spacing={2} alignItems="flex-end" sx={{ mt: 1, mb: 2, pb: 3, borderBottom: "1px solid #E8E8E8" }}>
                <Grid item xs={12} md={3}>
                    <TextField
                        placeholder="Search by offer name, code, campaign..."
                        size="small"
                        fullWidth
                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff" } }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon sx={{ color: "#888", fontSize: 20 }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>

                <Grid item xs={6} sm={3} md={2}>
                    <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Offer Type</Typography>
                    <FormControl size="small" fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14 } }}>
                        <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                            <MenuItem value="all">All Types</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={6} sm={3} md={2}>
                    <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Offer Category</Typography>
                    <FormControl size="small" fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14 } }}>
                        <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                            <MenuItem value="all">All Categories</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={6} sm={3} md={2}>
                    <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Funding Source</Typography>
                    <FormControl size="small" fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14 } }}>
                        <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                            <MenuItem value="all">All Sources</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={6} sm={3} md={3}>
                    <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Date Range</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]} sx={{ pt: 0, "& .MuiFormControl-root": { width: "100%" } }}>
                            <DatePicker
                                sx={{ width: "100%", "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14, overflow:"hidden" } }}
                                format="DD,MM,YYYY"
                                slotProps={{ textField: { size: "small", placeholder: "Select Date", fullWidth: true } }}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </Grid>
            </Grid>

            {/* Tabs */}
            <Box sx={{ borderColor: "divider" }}>
                <Tabs
                    value={0}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ borderBottom: "1px solid #D8D8D8" }}
                    TabIndicatorProps={{ sx: { backgroundColor: "#3FBEAC", height: "3px" } }}
                >
                    {[
                        { label: "All Offers", count: 256, active: true },
                        { label: "Active", count: 148 },
                        { label: "Scheduled", count: 28 },
                        { label: "Draft", count: 34 },
                        { label: "Under Review", count: 46 },
                        { label: "Paused", count: 12 },
                        { label: "Expired", count: 12 },
                        { label: "Disabled", count: 5 },
                    ].map((tab) => (
                        <Tab
                            key={tab.label}
                            sx={{ textTransform: "capitalize", fontSize: 14 }}
                            label={
                                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                    <Typography fontSize={14} component="span">{tab.label}</Typography>
                                    <Chip
                                        sx={{ color: tab.active ? "#fff" : "#535353", bgcolor: tab.active ? "#3FBEAC" : "#E8E8E8", fontSize: 12 }}
                                        label={tab.count}
                                    />
                                </Box>
                            }
                        />
                    ))}
                </Tabs>
            </Box>

            {/* Table */}
            <Box sx={{ my: 2 }}>
                <Paper elevation={0} sx={{ mb: 2, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
                    <Typography fontSize={16} fontWeight={600}>All Offers</Typography>

                    {selectedInfoRows.length > 0 && (
                        <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end", alignItems: "center", gap: 2 }}>
                            <Box display="flex" alignItems="center">
                                <Checkbox
                                    checked
                                    checkedIcon={
                                        <Box sx={{ width: 22, height: 22, borderRadius: 1, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#000" }}>
                                            <CheckIcon sx={{ color: "#fff", fontSize: 18 }} />
                                        </Box>
                                    }
                                    size="small"
                                />
                                <Typography fontSize={14}>{selectedInfoRows.length} selected</Typography>
                            </Box>

                            <Divider orientation="vertical" flexItem sx={{ borderColor: "#BCBCBC" }} />

                            <Typography fontSize={14}>Bulk actions:</Typography>

                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                <button style={{ border: "1px solid #04B22E33", fontSize: 14 }} className="btn px-3 d-flex align-items-center gap-1" onClick={handleActivate}>
                                    <PlayArrowOutlined sx={{ color: "#04B22E" }} /> Activate
                                </button>
                                <button style={{ border: "1px solid #FEB91E4D", fontSize: 14 }} className="btn px-3 d-flex align-items-center gap-1" onClick={handlePause}>
                                    <PauseOutlined sx={{ color: "#FEB91E" }} /> Pause
                                </button>
                                <button style={{ border: "1px solid #A8010133", fontSize: 14 }} className="btn px-3 d-flex align-items-center gap-1" onClick={handleDelete}>
                                    <DeleteOutline sx={{ color: "#A80101" }} /> Delete
                                </button>
                            </Stack>

                            <Divider orientation="vertical" flexItem sx={{ borderColor: "#BCBCBC" }} />

                            <button style={{ color: "#535353", fontSize: 14 }} className="btn btn-outline-light px-3 d-flex align-items-center gap-1" onClick={handleReset}>
                                <CloseOutlined sx={{ color: "#535353" }} /> Clear Selection
                            </button>
                        </Box>
                    )}
                </Paper>

                <Box className="data-grid-small" sx={{ width: "100%", overflowX: "auto" }}>
                    <Paper sx={{ minWidth: 900, "& .MuiDataGrid-cell": { fontSize: 13 }, "& .MuiDataGrid-columnHeaderTitle": { fontSize: 14, fontWeight: 600 } }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[5, 10, 20, 50]}
                            checkboxSelection
                            onRowSelectionModelChange={(newSelection) => {
                                setSelectedRows(newSelection);
                                setSelectedInfoRows(newSelection);
                            }}
                            sx={{ overflow: "hidden" }}
                            slotProps={{ pagination: { sx: { justifyContent: "end", display: "flex", alignItems: "center" } } }}
                        />
                    </Paper>

                    <StatusInfoPopover anchorEl={anchorEl} onClose={handleStatusInfoClose} data={selectedStatusData} />
                </Box>
            </Box>

            <Grid container spacing={3} sx={{ mt: 1 }}>
                <Grid item xs={12} md={8}>
                       <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
           height: { xs: "auto", md: 350 },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Offer Revenue Trend ( Last 30 Days)</Typography>
                 <Box sx={{ display: "flex", justifyContent: "flex-end"}}>
                            <FormControl size="small" sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", fontSize: 13 } }}>
                                <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                    <MenuItem value="all">Last 30 Days</MenuItem>
                                    <MenuItem value="active">Last 20 Days</MenuItem>
                                    <MenuItem value="inactive">Last 10 Days</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
            
        </Box>
        <Box >
          

                        <Box sx={{ width: "100%", height: 260 }}>
                            <ResponsiveContainer>
                                <AreaChart data={data}>
                                    <defs>
                                        <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#3FBEAC" stopOpacity={0.25} />
                                            <stop offset="95%" stopColor="#34B3F1" stopOpacity={0} />
                                        </linearGradient>
                                    </defs>
                                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                    <XAxis dataKey="date" ticks={visibleTicks} interval={0} axisLine={false} tickLine={false} />
                                    <YAxis domain={[0, 200000]} ticks={[0, 40000, 80000, 120000, 160000, 200000]} tickFormatter={(v) => `${v / 1000}K`} axisLine={false} tickLine={false} />
                                    <Tooltip />
                                    <Area type="monotone" dataKey="value" stroke="#46C1B6" strokeWidth={4} fill="url(#colorValue)" />
                                </AreaChart>
                            </ResponsiveContainer>
                        </Box>
        </Box>
    </Card>
                

                    <Grid container spacing={3} sx={{ my: 1 }} >
                        <Grid item xs={12} md={6}>
                                <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", md: 270 },
            
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
                flexWrap: "wrap",
                gap: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Offer Health</Typography>
        
            
        </Box>
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
          <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 2, flexGrow: 1 }}>
                                    <Box sx={{ width: 180, height: 180, flexShrink: 0 }}>
                                        <ResponsiveContainer>
                                            <PieChart>
                                                <Pie data={donutData} dataKey="value" innerRadius={55} outerRadius={78} startAngle={90} endAngle={-270}>
                                                    {donutData.map((item) => (<Cell key={item.name} fill={item.color} />))}
                                                </Pie>
                                                <text x="50%" y="50%" textAnchor="middle" fontSize="28" fontWeight="700">{total}</text>
                                                <text x="50%" y="62%" textAnchor="middle" fontSize="13">Total</text>
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </Box>

                                    <Box sx={{ flexGrow: 1, minWidth: 140 }}>
                                        {donutData.map((item) => (
                                            <Box key={item.name} sx={{ display: "flex", alignItems: "center", gap: 1, my: 1 }}>
                                                <Box sx={{ width: 9, height: 9, borderRadius: "50%", bgcolor: item.color, flexShrink: 0 }} />
                                                <Typography fontSize={12.5} noWrap>
                                                    {item.value} {item.name} ({((item.value / total) * 100).toFixed(1)}%)
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
        </Box>
    </Card>
                   
                        </Grid>

                        <Grid item xs={12} md={6}>
                               <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", md: 270 },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
                flexWrap: "wrap",
                gap: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Most Purchased Services in Offers</Typography>
                <Link sx={{ color: "#159D89", textDecorationLine: "none", fontSize: 13, display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                    View all <ArrowForward sx={{ fontSize: 14 }} />
                </Link>
        </Box>
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
               <List sx={{ py: 0 }}>
                                    {mostPurchased.map((s, i) => (
                                        <ListItem key={s.name} sx={{ borderBottom: i < mostPurchased.length - 1 ? "1px solid #E8E8E8" : "none", px: 0 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", gap: 2, py: 1.5 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, flexShrink: 0 }}>
                                                    <Box sx={{ width: 25, height: 25, borderRadius: "50%", bgcolor: s.bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        {s.icon}
                                                    </Box>
                                                    <Typography fontSize={13.5} noWrap>{s.name}</Typography>
                                                </Box>

                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexGrow: 1, minWidth: 0, justifyContent: "flex-end" }}>
                                                    <Typography fontSize={12.5} color="text.secondary" noWrap>{s.orders}</Typography>
                                                    <LinearProgress
                                                        variant="determinate"
                                                        value={s.value}
                                                        sx={{ height: 7, borderRadius: 4, backgroundColor: "#DADADA", flex: 1, minWidth: 40, maxWidth: 100, "& .MuiLinearProgress-bar": { backgroundColor: "#3FBEAC", borderRadius: 10 } }}
                                                    />
                                                    <Typography fontSize={13} sx={{ width: 32, flexShrink: 0 }}>{s.value}%</Typography>
                                                </Box>
                                            </Box>
                                        </ListItem>
                                    ))}
                                </List>
        </Box>
    </Card>
                    
                        </Grid>
                    </Grid>

                    <Grid container spacing={3} alignItems="center" my={1}>
                        <Grid item xs={12} md={6}>
                             <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", md: 270 },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
                flexWrap: "wrap",
                gap: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Top User Segments</Typography>
                <Link sx={{ color: "#159D89", textDecorationLine: "none", fontSize: 13, display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                    View all <ArrowForward sx={{ fontSize: 14 }} />
                </Link>
            
        </Box>
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                 <List sx={{ py: 0 }}>
                                    {userSegments.map((s, i) => (
                                        <ListItem key={s.name} sx={{ borderBottom: i < userSegments.length - 1 ? "1px solid #E8E8E8" : "none", px: 0 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 1.5, py: 1.5 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0, minWidth: 130 }}>
                                                    <Box sx={{ width: 23, height: 23, borderRadius: "50%", bgcolor: "#3FBEAC", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        {s.icon}
                                                    </Box>
                                                    <Typography fontSize={12.5} noWrap>{s.name}</Typography>
                                                </Box>
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={s.value}
                                                    sx={{ height: 7, borderRadius: 4, backgroundColor: "#DADADA", flex: 1, "& .MuiLinearProgress-bar": { backgroundColor: "#3FBEAC", borderRadius: 10 } }}
                                                />
                                                <Typography fontSize={13} sx={{ width: 32, flexShrink: 0, textAlign: "right" }}>{s.value}%</Typography>
                                            </Box>
                                        </ListItem>
                                    ))}
                                </List>
        </Box>
    </Card>
                  
                        </Grid>

                        <Grid item xs={12} md={6}>
                              <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", md: 270   },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
                flexWrap: "wrap",
                gap: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Offer Conversion Funnel</Typography>
        
                <Link sx={{ color: "#159D89", textDecorationLine: "none", fontSize: 13, display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                    View all <ArrowForward sx={{ fontSize: 14 }} />
                </Link>
               
    
        </Box>
         <FunnelChart/>
    
    </Card>
                       
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} md={4}>
                
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, height: "100%" }}>
                  
                              <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", md: 270 },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
                flexWrap: "wrap",
                gap: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Top Performing Offers</Typography>
            
                <Link sx={{ color: "#159D89", textDecorationLine: "none", fontSize: 13, display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                    View all <ArrowForward sx={{ fontSize: 14 }} />
                </Link>
            
        </Box>
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
            <List sx={{ py: 0 }}>
                                {topOffers.map((o, i) => (
                                    <ListItem key={o.name} sx={{ borderBottom: i < topOffers.length - 1 ? "1px solid #E8E8E8" : "none", px: 0 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", gap: 1, py: 1.5 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, minWidth: 0 }}>
                                                <Box sx={{ width: 30, height: 30, borderRadius: "50%", border: "1px solid #E8E8E8", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                    {o.icon}
                                                </Box>
                                                <Typography fontSize={13.5} noWrap>{o.name}</Typography>
                                            </Box>
                                            <Typography fontSize={13.5} fontWeight={700} sx={{ flexShrink: 0 }}>{o.revenue}</Typography>
                                            <Typography fontSize={13.5} sx={{ flexShrink: 0, width: 36, textAlign: "right" }}>{o.roi}</Typography>
                                        </Box>
                                    </ListItem>
                                ))}
                            </List>
                            
        </Box>
    </Card>
                         <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", md: 270 },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
                flexWrap: "wrap",
                gap: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Expiring Soon</Typography>
            
                <Link sx={{ color: "#159D89", textDecorationLine: "none", fontSize: 13, display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                    View all <ArrowForward sx={{ fontSize: 14 }} />
                </Link>
            
        </Box>
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
           <List sx={{ py: 0 }}>
                                {expiringSoon.map((e, i) => (
                                    <ListItem key={e.name} sx={{ borderBottom: i < expiringSoon.length - 1 ? "1px solid #E8E8E8" : "none", px: 0 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", gap: 1, py: 1.5 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, minWidth: 0 }}>
                                                <Box sx={{ width: 30, height: 30, borderRadius: "50%", border: "1px solid #E8E8E8", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                    {e.icon}
                                                </Box>
                                                <Typography fontSize={13.5} noWrap>{e.name}</Typography>
                                            </Box>
                                            <Typography fontSize={13} color="text.secondary" sx={{ flexShrink: 0 }} noWrap>{e.expires}</Typography>
                                        </Box>
                                    </ListItem>
                                ))}
                            </List>
                            
        </Box>
    </Card>
                         <Card
        elevation={0}
        sx={{
            border: "1px solid #ECECEC",
            borderRadius: 3,
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            height: { xs: "auto", md: 365 },
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ECECEC",
                pb: 1.5,
                mb: 1,
                flexWrap: "wrap",
                gap: 1,
            }}
        >
            <Typography fontWeight={600} fontSize={15}>Recent Activity</Typography>
            
                <Link sx={{ color: "#159D89", textDecorationLine: "none", fontSize: 13, display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                    View all <ArrowForward sx={{ fontSize: 14 }} />
                </Link>
            
        </Box>
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
          <List sx={{ py: 0 }}>
                                {recentActivity.map((a, i) => (
                                    <ListItem key={i} sx={{ borderBottom: i < recentActivity.length - 1 ? "1px solid #E8E8E8" : "none", px: 0 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", gap: 1, py: 1.5 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, minWidth: 0 }}>
                                                <Box sx={{ width: 32, height: 32, borderRadius: "50%", border: "1px solid #E8E8E8", flexShrink: 0, overflow: "hidden" }}>
                                                    <Box component="img" src={agentimg} alt="" sx={{ width: "100%", height: "100%" }} />
                                                </Box>
                                                <Typography fontWeight={600} fontSize={12} sx={{ wordBreak: "break-word" }}>
                                                    {a.user} <Typography component="span" color="text.secondary" fontSize={12}>{a.action}</Typography> {a.offer}
                                                </Typography>
                                            </Box>
                                            <Typography fontSize={12} color="text.secondary" sx={{ flexShrink: 0, whiteSpace: "nowrap" }}>{a.time}</Typography>
                                        </Box>
                                    </ListItem>
                                ))}
                            </List>
                            
        </Box>
    </Card>

        
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default OffersIncentives;
